import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceStreamGeneralInfo';
export const useSourceStreamGeneralInfoTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Базовые параметры',
    fields: {
      name: 'Название',
      description: 'Описание',
      group: 'Группа',
    },
    validation: {
      required: 'Обязательное поле',
      name_pattern: 'Допустимы латинские буквы, цифры, «-» и «_»',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Basic parameters',
    fields: {
      name: 'Name',
      description: 'Description',
      group: 'Group',
    },
    validation: {
      required: 'Required field',
      name_pattern: 'Only Latin letters, digits, "-" and "_" are allowed',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Parámetros básicos',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      group: 'Grupo',
    },
    validation: {
      required: 'Campo obligatorio',
      name_pattern: 'Solo se permiten letras latinas, dígitos, "-" y "_"',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Parâmetros básicos',
    fields: {
      name: 'Nome',
      description: 'Descrição',
      group: 'Grupo',
    },
    validation: {
      required: 'Campo obrigatório',
      name_pattern: 'Apenas letras latinas, dígitos, "-" e "_" são permitidos',
    },
  },
}) : {}) as Record<string, unknown>;
